import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {ConfigService, initializeJam, initializeSentry} from '@q9elements/ui-kit/common';
import {AppModule} from './app/app.module';
import {hideFromWappalyzer} from './app/util/wappalyzer';
import {environment} from './environments/environment';

if (ConfigService.environment.production) {
  const ignoreErrors = [
    'unauthorized',
    'no_password',
    'authentication_failed',
    'The database connection is closing',
    'A network error (such as timeout, interrupted connection or unreachable host) has occurred.\n',
    'Unspecified error.',
    'ChunkLoadError: Loading chunk'
  ];
  enableProdMode();

  initializeSentry(ignoreErrors);

  initializeJam();
}

if (ConfigService.environment.production) {
  console.log(`Version: ${environment.version}`);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => hideFromWappalyzer())
  .catch(err => console.log(err));
